import { renderInDocument } from '@spotahome/soyuz/client';

import '@spotahome/marketplace-common/src/scss/init.scss';

import ShowRentableUnitPage from './main';

renderInDocument(ShowRentableUnitPage);
